export default "__VITE_ASSET__CTruAdOr__"